import React from "react";
import { PieChart } from "../../ui/Graph";
import PropTypes from "prop-types";

const PieChartReport = ({ data = {}, loading = false }) => {
  return (
    <div className="flex flex-col gap-4 bg-white rounded-lg px-4 py-2">
      <PieChart
        title="Distribución de SMS por tipo de envío"
        labels={["API", "Campañas"]}
        dataSets={[Number(data?.i_api), Number(data?.i_campaigns)]}
        label="No. de SMS"
        loading={loading}
      />
    </div>
  );
};

PieChartReport.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default PieChartReport;
